// extracted by mini-css-extract-plugin
module.exports = {"fullscreenLoading":"Loading_fullscreenLoading__1-6_N"};